export const TERMS_AGREEMENT = 'Du måste först godkänna villkoren i vår integritetspolicy'

export const ERROR_SUBMIT_INQUIRY = 'Något gick fel. Försök igen om en liten stund'

export const SUCCESS_SUBMIT_INQUIRY = 'Tack för din förfrågan!'

export const AUTOCOMPLETE_LOADING_TEXT = 'Läser in förslag...'

export const AUTOCOMPLETE_ERROR_MESSAGE = 'Det finns inga förslag som matchar din sökning'